import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as reloadForm from '@elements/reload-form';
reloadForm.init({
    addUrlParams: true
});

